import { useEffect, useState } from "react";
import Navbar from "../navbar/navbar";
import { formatDate, getBase64ImageFromUrl, getReceiptList } from "../../services/receipt.service";
import Swal from "sweetalert2";
import { getGotraMasterList, getNakshatraMasterList, getPoojaMasterList } from "../../services/admin.service";
import { FaEye } from "react-icons/fa6";
import PrathanaReceiptPrint from "../../print/prathanaReceiptPrint";
import headerLogo from "../../assets/images/DailyPoojaReport.png"
import KanikaReceiptPrint from "../../print/kanikaReceiptPrint";
import ReceiptPrint from "../../print/receiptPrint";
import Datatable from "../../datatable/Datatable";
import "../reports/reportModule.css";
import KanikaReceiptPrint_40Col from "../../print/kanikaReceiptPrint_40Col";
import PrathanaReceiptPrint_40Col from "../../print/prathanaReceiptPrint_40Col";
import SevaReceiptPrint_40Col from "../../print/sevaReceiptPrint_40Col";
import { ReportListHeading, ReportListLoading } from "../reports/ReportListUi";

const PrintReceiptListComponent = () => {

    const [receiptList, setReceiptList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [poojaMasterList, setPoojaMasterList] = useState([]);
    const today = new Date();
    const [month, setMonth] = useState(today.getMonth() + 1);
    const [year, setYear] = useState(today.getFullYear());

    const months = [
        { value: 1, label: 'January' }, { value: 2, label: 'February' }, { value: 3, label: 'March' },
        { value: 4, label: 'April' }, { value: 5, label: 'May' }, { value: 6, label: 'June' },
        { value: 7, label: 'July' }, { value: 8, label: 'August' }, { value: 9, label: 'September' },
        { value: 10, label: 'October' }, { value: 11, label: 'November' }, { value: 12, label: 'December' },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2015 + 1 }, (_, i) => currentYear - i);

    useEffect(() => {
        fetchReceiptList();
    }, [month, year]);


    useEffect(() => {
        fetchPoojaList();
    }, []);

    const fetchPoojaList = async () => {
        try {
            const response = await getPoojaMasterList();
            if (response) {
                setPoojaMasterList(response);
            } else {
                Swal.fire("Error", "Failed to fetch pooja list", "error");
                setPoojaMasterList([]);
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching pooja list", "error");
            console.error(error);
        }
    };

    const fetchReceiptList = async () => {
        setLoading(true);
        try {
            const response = await getReceiptList({ month, year });
            if (response) {
                setReceiptList(response);
            } else {
                Swal.fire("Error", "Failed to fetch receipt list", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const paymentTypes = {
        'CA': 'Cash',
        'CQ': 'Cheque',
        'DC': 'Card',
        'RT': 'RTGS',
        'UP': 'UPI',
        'NB': 'Net Banking',
        'WL': 'Wallet',
                'Online': 'Online',
    }

    const handlePrint = async (item,type) => {
        const base64Logo = await getBase64ImageFromUrl(headerLogo);
        const nakshatraList = await getNakshatraMasterList();
        const gotraList = await getGotraMasterList();
        if (item.poojaType1 === '99') {
            type === "pos" ? await KanikaReceiptPrint_40Col(item, base64Logo, nakshatraList, gotraList) : await KanikaReceiptPrint(item, base64Logo, nakshatraList, gotraList);
        } else if (item.poojaType1 === '98') {
             type === "pos" ? await PrathanaReceiptPrint_40Col(item, base64Logo, nakshatraList, gotraList) : await PrathanaReceiptPrint(item, base64Logo, nakshatraList, gotraList);
        } else {
             type === "pos" ? await SevaReceiptPrint_40Col(item, base64Logo, poojaMasterList, nakshatraList, gotraList) : await ReceiptPrint(item, base64Logo, poojaMasterList, nakshatraList, gotraList);
        }
    };

    const grandTotal = receiptList.reduce((sum, item) => sum + (item.totalAmount || 0), 0);

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Receipt No", selector: (row) => row.receiptNo, sortable: true, align: 'text-center' },
        { name: "Receipt Date", selector: (row) => row.receiptDate, sortable: true, align: 'text-center' },
        { name: "Name of Devotee", selector: (row) => row.devoteeName, sortable: true, align: 'text-start' },
        { name: "Mobile", selector: (row) => row.mobile, sortable: true, align: 'text-center' },
        { name: "Seva Name", selector: (row) => row.poojaName, sortable: true, align: 'text-start' },
        { name: "Seva Date", selector: (row) => row.poojaDateTime1, sortable: true, align: 'text-center' },
        { name: "Total Amount", selector: (row) => row.totalAmount, sortable: true, align: 'text-center' },
        { name: "Payment Mode", selector: (row) => row.paymentType, sortable: true, align: 'text-center' },
        { name: "Action", selector: (row) => row.action, sortable: true, align: 'text-center' },
    ];

    const mappedData = () => {
        return receiptList.map((item, index) => ({
            sn: index + 1,
            receiptNo: item.receiptNo || '-',
            receiptDate: formatDate(item.receiptDate) || '-',
            devoteeName: item.devoteeName || '-',
            mobile: item.mobile || '-',
            poojaName: item.poojaName || '-',
            poojaDateTime1: formatDate(item.poojaDateTime1) || '-',
            totalAmount: item.totalAmount || '-',
            paymentType: paymentTypes[item.paymentType] || '-',
            action: (
                <>
                    <button className="print me-2" onClick={() => handlePrint(item,"normal")}><FaEye /></button>
                    <button className="posprint" onClick={() => handlePrint(item,"pos")}><FaEye /></button>
                </>
            )
        }))
    }

    return (
        <div className="card report-list-page">
            <Navbar />
            <ReportListHeading title="Receipt List" subtitle="Browse receipts by month and year, with print options for each record." />
            <div className="report-list-toolbar rowHeadercolor">
                {/* Center: Month and Year */}
                <div className="col-md-6 offset-md-3 d-flex justify-content-center">
                    <div className="report-list-period-filter d-flex align-items-center">
                        <label className="me-2 mb-0 fw-bold">Month:</label>
                        <select
                            className="form-select report-list-month-select me-3"
                            value={month}
                            onChange={(e) => setMonth(parseInt(e.target.value))}
                        >
                            {months.map(m => (
                                <option key={m.value} value={m.value}>{m.label}</option>
                            ))}
                        </select>

                        <label className="me-2 mb-0 fw-bold">Year:</label>
                        <select
                            className="form-select report-list-year-select"
                            value={year}
                            onChange={(e) => setYear(parseInt(e.target.value))}
                        >
                            {years.map(y => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Right: Grand Total */}
                <div className="report-list-total col-md-3 text-end fw-bold">
                    Grand Total: ₹{grandTotal.toLocaleString('en-IN')}
                </div>
            </div>
            <div id="card-body customized-card" className="report-list-table">
                {loading ? <ReportListLoading message="Loading receipts..." /> : <Datatable columns={columns} data={mappedData()} />}
            </div>
        </div >
    );
};

export default PrintReceiptListComponent;